<template>
  <div>
    <UrlToolsMigrationModal
      v-model="dialog"
      @close="handleClose"
    />
  </div>
</template>

<script>
import UrlToolsMigrationModal from '@/components/Contents/UrlTools/UrlToolsMigrationModal.vue'

export default {
  name: 'UrlTools',
  components: {
    UrlToolsMigrationModal,
  },
  data () {
    return {
      dialog: true,
    }
  },
  methods: {
    handleClose () {
      if (this.$route.path === '/ferraments-url') {
        this.$router.push({ path: '/dashboard' })
      }
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/Contents/UrlTools/UrlTools.vue